$("table.interactive").each(function dataTablePreRequisites(idx) {
  var $table = $(this);

  $table.find("tbody tr").click(function toggleRow(e) {
    var $tr = $(this);
    if (!e.shiftKey && !e.metaKey && !e.ctrlKey) {
      $tr.siblings().removeClass("selected");
    }
    $(this).toggleClass("selected");
  });


  if (typeof $.fn.DataTable !== "function") {
    $("<link/>", {
      rel: "stylesheet",
      type: "text/css",
      href: "https://cdn.datatables.net/1.10.16/css/jquery.dataTables.min.css"
    }).appendTo("head");
    $.getScript("https://cdn.datatables.net/1.10.16/js/jquery.dataTables.min.js", scriptLoaded);
  } else {
    scriptLoaded();
  }

  function scriptLoaded() {
    var øTable, åøFilter;

    $table.on("init.dt", dtLoaded);

    if ($table.hasClass("tariffs")) {
      $.fn.dataTableExt.oApi.fnGetColumnData = function getColData(oSettings, iColumn, bUnique, bFiltered, bIgnoreEmpty) {
        var aiRows, asResultData, i, aData, sValue;

        // check that we have a column id
        if (typeof iColumn == "undefined") {
          return new Array();
        }

        // by default we only want unique data
        if (typeof bUnique == "undefined") {
          bUnique = true;
        }

        // by default we do want to only look at filtered data
        if (typeof bFiltered == "undefined") {
          bFiltered = true;
        }

        // by default we do not want to include empty values
        if (typeof bIgnoreEmpty == "undefined") {
          bIgnoreEmpty = true;
        }

        // use only filtered rows
        if (bFiltered == true) {
          aiRows = oSettings.aiDisplay;
        } else {
          aiRows = oSettings.aiDisplayMaster;
        }
        // all row numbers

        // set up data array
        asResultData = new Array();

        for (i = 0, c = aiRows.length; i < c; i++) {
          iRow = aiRows[i];
          aData = this.fnGetData(iRow);
          sValue = aData[iColumn];

          // ignore empty values?
          if (bIgnoreEmpty == true && sValue.length == 0) {
            continue;
          } else if (bUnique == true && jQuery.inArray(sValue, asResultData) > -1) {
            continue;
          } else {
            asResultData.push(sValue);
          }
        }

        return asResultData;
      };


      $table.before(
        "<form id=\"tariffsForm\" class=\"standard compact\">\
          <div id=\"tariffsFilter\" class=\"grid\">\
          </div>\
        </form>\
        <br/>"
      );

      øTable = $table.dataTable({
        "bPaginate": false,
        "bSort": false,
        "sDom": ""
      });

      åøFilter = [
        {
          title: "Issuer",
          cols: 4,
          select: true,
          tableCol: 0
        },
        {
          title: "Tariff Type",
          cols: 4,
          select: true,
          tableCol: 1,
          options: [
            {
              name: "All",
              value: ""
            },
            {
              name: "Rates",
              value: "!(Tariff Index)|(Adoption Notice)|(Rules and Regulations)"
            },
            {
              name: "Rules and Regulations",
              value: "Rules and Regulations"
            },
            {
              name: "Adoption Notice",
              value: "Adoption Notice"
            },
            {
              name: "Tariff Index",
              value: "Tariff Index"
            }
          ]
        },
        {
          title: "Origin",
          cols: 2,
          select: false,
          tableCol: 1
        },
        {
          title: "Destination",
          cols: 2,
          select: false,
          tableCol: 2,
        },
        {
          title: "Product Type",
          cols: 2,
          select: true,
          tableCol: 4
        },
        {
          title: "Regulator",
          cols: 4,
          select: true,
          tableCol: 5
        },
        {
          title: "Tariff No.",
          cols: 2,
          select: false,
          tableCol: 6
        }
      ];

      // filterArray = ["Issuer", "Origin", "Tariff Type", "Destination", "Product Type", "Regulator", "Tariff No."];
      // filterWidthArray = [2, 2, 2, 2, 1, 2, 1];
      // selArray = ["Issuer", "Tariff Type", "Product Type", "Regulator"];

      jQuery("#tariffsFilter").each(function theFilters() {
        var $filters = $(this);
        åøFilter.forEach(function eachFilter(elm, idx) {
          var $filter = $("<div class=\"ws-" + elm.cols + "\"/></div>");
          var $labsel, $sel;

          if (elm.select) {
            $labsel = $("<label class=\"select\">" + elm.title + "<br/></label>");
            $sel = $("<select data-col=\"" + elm.tableCol + "\"/>");

            if (elm.options) {
              elm.options.forEach(function eachOption(opt) {
                $sel.append("<option value=\"" + opt.value + "\">" + opt.name + "</option>");
              });
            } else {
              $sel.append(fnCreateSelect(øTable.fnGetColumnData(elm.tableCol)));
            }

            $sel.appendTo($labsel);
            $filter.append($labsel);
          } else {
            $filter.append("<label>" + elm.title + "<br/><input data-col=\"" + elm.tableCol + "\" />");
          }

          $filter.appendTo($filters);
        });

        $filters.append(
          "<div class=\"ws-4 down\" style=\"text-align:right\">\
            <button type=\"button\" class=\"inline\" name=\"filterRun\" id=\"filterRun\">Find Tariffs</button>\
            <button type=\"reset\" class=\"inline\" name=\"filterReset\" id=\"filterReset\">Clear Form</button>\
          </div>"
        );
      });

      //Initially set a junk filter so no results are found, do it after you build the filters because they will be empty otherwise.
      øTable.fnFilter("~!@#$%^&*(((())_+");

      jQuery("#filterRun").click(function filterRun() {
        øTable.fnFilter("");
        øTable.fnFilter("", 1, false, true);
        jQuery("#tariffsFilter select, #tariffsFilter input").each(function eachInput() {
          var val = jQuery(this).val();
          var col = Number(jQuery(this).attr("data-col"));
          if (col === 1) {
            if (val.substr(0, 1) === "!") {
              øTable.fnFilter("^(?:(?" + val + ").)*$", 1, true, false);
            } else if (val.length > 0) {
              øTable.fnFilter(val, 1, false, true);
            }
          } else {
            øTable.fnFilter(val, col);
          }
        });
        $table.fadeIn();
      });

      jQuery("#filterReset").click(function resetClicked(e) {
        $table.fadeOut();
        jQuery("#tariffsFilter select, #tariffsFilter input").each(function eachInput() {
          var $elem = jQuery(this);
          var $col = $elem.attr("data-col");
          øTable.fnFilter("", $col);
          øTable.fnFilter("~!@#$%^&*(((())_+");
        });
      });

      function fnCreateSelect(aData) {
        var i;
        var r = "<option value=\"\">All</option>";
        var iLen = aData.length;

        // First sort it normally
        aData.sort();

        aData.sort(function sortData(a, b) {
          if (b === "NRS") {
            return -1;
          } else if (a === "NRS") {
            return 1;
          } else {
            return 0;
          }
        });

        for (i = 0; i < iLen; i++) {
          r += "<option value=\"" + aData[i] + "\">" + aData[i] + "</option>";
        }
        return r;
      }

    } else {
      øTable = $table.DataTable();
    }
  }

  function dtLoaded(e, settings, json) {
    $(".dataTables_wrapper select").each(function eachSelect() {
      var $select = $(this);
      var $parent = $select.parent();
      if (/Show [0-9]+ entries/i.test($parent.text())) {
        $select.detach();
        $parent.html("Show:&nbsp;&nbsp;<br/>");
        $parent.append($select);
        $parent.addClass("select");
      }
    });
  }
});
